import React from 'react'
import { useParams } from "react-router-dom";
import { LoadingComponent, EmptyResult } from 'usbc-web-react-library';
import ErrorLayout from '../Shared/ErrorLayout/ErrorLayout'
import RedirectingTo from '../Shared/RedirectingTo/RedirectingTo'
import { useNavigate } from 'react-router-dom';
import { currencyFormat, getCategoryIcon } from '../Shared/helpers'
import useApi from '../../hooks/useApi'
import './FindALeague.css'
import { baseUrl } from '../../hooks/useApi'
import { config } from '../../config'

function FindALeague(props) {

    const {
        fetchData: getcenter,
        response: center,
        loading: centerLoading,
    } = useApi();

    const {
        fetchData: getleagues,
        response: leagues,
        loading: leaguesLoading,
    } = useApi();

    let navigate = useNavigate();

    let { slug } = useParams();

    let bannerUrl = config.ApiUrl + baseUrl + 'getcenterbanner/' + slug;
    let logoUrl = config.ApiUrl + baseUrl + 'getcenterlogo/' + slug;

    React.useEffect(() => {
        if (slug != null) {
            getcenter({ url: 'getcenter/' + slug });
            getleagues({ url: 'getleagues/' + slug });
        }
    }, []);

    const loginCode = new URLSearchParams(window.location.search).get(
        'code'
    );

    if (!!loginCode) {
        return (<LoadingComponent isLoading={() => true} description='Signing you in'></LoadingComponent>);
    }

    if (!slug) {
        return (<RedirectingTo linkTitle="Bowl.com" url="http://bowl.com/" timeout={2000} />);
    }

    if (centerLoading == false && center == null) {
        return (<ErrorLayout title="Center is not found" />);
    }


    function getBase64(source) {
        return `data:image/png;base64,${source}`;
    }

    function registerHandler(league) {
        navigate('/register/' + league.id + '/' + league.season + '/' + slug)
    }

    return (
        <div className='find-league'>

            <div className="card header-league text-white">
                <img src={bannerUrl} className="card-img center-img" alt="..." />
                <div className="card-img-overlay custom-image-overlay" style={{ display: "flex", alignItems: "flex-end" }}>
                    <div style={{ width: "100%" }}>
                        <div className="row g-0">
                            <div className="col-sm-2 col-3" style={{ display: "flex" }}>
                                <img src={logoUrl} alt="..." className='card-logo-league' style={{ maxWidth: "100%" }} />
                            </div>
                            <div className="col-sm-10 col-9 card-header-league">
                                <div className="card-body card-body-league">
                                    <LoadingComponent isLoading={() => centerLoading === true} description='Loading center' isDarkBackground={true}>
                                        <h2 className="card-title header-league-title">{center?.name} - Find a League</h2>
                                        <p className="d-none d-sm-block card-text header-league-text">Join a Bowling League at {center?.name}!</p>
                                        <p className="d-none d-sm-block card-text header-league-text">{center?.address}</p>
                                    </LoadingComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {centerLoading == false &&
                <div className='d-block d-sm-none sub-text'>
                    <p className="card-text header-league-text">Join a Bowling League at {center?.name}!</p>
                    <p className="card-text header-league-text">{center?.address}</p>
                </div>
            }
            <figure className="text-center border-bottom">
                <h3 className="mt-4 mt-2 text-secondary">Leagues</h3>
            </figure>

            <LoadingComponent isLoading={() => leaguesLoading == true} description='Loading leagues'>
                {(leagues != null && leagues.length > 0) ?
                    <>
                        <div className="row ps-2 pe-2">
                            {leagues.map((league, index) =>
                                <div key={index} className="col-sm-6 mb-3 card-radio" onClick={() => { registerHandler(league) }}>
                                    <div className={"card h-100 card-block animated-league-item"}>
                                        <div className="card-body">
                                            <h4 className="card-title">{league.name}</h4>
                                            <p className="card-text"><small>{league.start} - {league.end}</small></p>
                                            <p className="card-text">{league.welcomeMessage}</p>
                                        </div>
                                        <div className="card-footer">
                                            <div className=''>
                                                <span className="badge rounded-pill league-badge day-badge">{league.dayOfWeek}</span>
                                                <span className="badge rounded-pill league-badge time-badge">{league.time}</span>
                                                <span className="badge rounded-pill league-badge price-badge">{currencyFormat(league.price)}</span>
                                                <span className={`badge rounded-pill league-badge category-badge-${league.category}`}>{getCategoryIcon(league.category)} {league.category}</span>
                                            </div>

                                            <button type="button" className="btn btn-primary bowl-btn btn-league" onClick={() => { registerHandler(league) }}>Register</button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                    :

                    <EmptyResult>No league results</EmptyResult>
                }
            </LoadingComponent>

        </div>
    )
}

FindALeague.propTypes = {}

export default FindALeague
